import React, { useEffect, useState } from "react";
import {
  UserCircleIcon,
  EyeIcon,
  AnnotationIcon,
  BookOpenIcon,
} from "@heroicons/react/outline";
import bgLight from "../../assests/img/bg-bursa-light.png";
import bgDark from "../../assests/img/bg-bursa-dark.png";
import { connect } from "react-redux";
import SMSelect from "../../elements/select/SMSelect";
import InputSingle from "../../elements/input/InputSingle";
import ButtonPrimary from "../../elements/button/ButtonPrimary";
import { Link } from "react-router-dom";
import axiosAPI from "../../utils/axios-api";
import SMModal from "../../elements/modals/SMModal";
import Lottie from "react-lottie";
import emptyIcon from "../../assests/lottie/empty.json";
import SMFilter from "../../elements/filter/SMFilter";
import SMFilterBursa from "../../elements/filter/SMFilterBursa";
import SkeletonCard from "../../elements/loading/SkeletonCard";
import NotFound from "../../elements/not-found/NotFound";
import swal from "sweetalert2";

const API = process.env.REACT_APP_API;

function Bursa(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: emptyIcon,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const [bursaKuesioner, setbursaKuesioner] = useState([]);
  const [kuesionerTerbuka, setkuesionerTerbuka] = useState([]);
  const [datauser, setdatauser] = useState({});

  // modal
  const [modalResponden, setmodalResponden] = useState(null);
  const [loadingDaftarResponden, setloadingDaftarResponden] = useState(0);

  const [loadingGetData, setloadingGetData] = useState(0);

  const [nextPaginate, setNextPaginate] = useState(0);
  const [prevPaginate, setPrevPaginate] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [perPage, setPerPage] = useState(0);
  const [fromPage, setFromPage] = useState(0);
  const [toPage, setToPage] = useState(0);
  const [showPerPage, setShowPerPage] = useState(0);

  useEffect(() => {
    // return () => {
    //   window.removeEventListener("storage");
    // };

    let user = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};

    setdatauser(user);

    getBursaKuesioner();
    if (!!user.token) {
      getMyKuesioner();
    }
  }, []);

  let kTerbuka = [1, 2, 3, 4, 5];

  let bg = props.themes !== "light" ? bgDark : bgLight;

  function getBursaKuesioner(filter) {
    setloadingGetData(1);
    let param =
      "kuesioner/bursa-kuesioner?include=dataUser&page[size]=9&page[number]=0&sort=-created_at";
    let f = !!filter ? `${param}&${filter}` : param;
    axiosAPI
      .get(API + f)
      .then((res) => {
        setbursaKuesioner(res.data.data);

        setNextPaginate(res.data.meta.current_page + 1);
        setPrevPaginate(res.data.meta.current_page - 1);
        setCurrentPage(res.data.meta.current_page);
        setLastPage(res.data.meta.last_page);
        setPerPage(res.data.meta.per_page);
        setFromPage(res.data.meta.from);
        setToPage(res.data.meta.to);

        if (res.data.data.length === 0) {
          setloadingGetData(4);
        } else {
          setloadingGetData(2);
        }
      })
      .catch((err) => {
        setloadingGetData(3);
      });
  }

  // paginate
  function nextPage() {
    let nextPage = nextPaginate;
    let pageNow = currentPage;
    let pageLast = lastPage;
    let pageSize = showPerPage ? showPerPage : 10;

    if (pageNow >= pageLast) {
      return false;
    } else {
      axiosAPI
        .get(
          API +
            "kuesioner/bursa-kuesioner?include=dataUser&page[size]=" +
            pageSize +
            "&page[number]=" +
            nextPage +
            "&sort=-created_at"
        )
        .then((res) => {
          setbursaKuesioner(res.data.data);

          setNextPaginate(res.data.meta.current_page + 1);
          setPrevPaginate(res.data.meta.current_page - 1);
          setCurrentPage(res.data.meta.current_page);
          setLastPage(res.data.meta.last_page);
          setPerPage(res.data.meta.per_page);
          setFromPage(res.data.meta.from);
          setToPage(res.data.meta.to);

          if (res.data.data.length === 0) {
            setloadingGetData(4);
          } else {
            setloadingGetData(2);
          }
        })
        .catch((err) => {
          setloadingGetData(3);
        });
    }
  }

  function prevPage() {
    let prevPage = prevPaginate;
    let pageNow = currentPage;
    let pageLast = lastPage;
    let pageSize = showPerPage ? showPerPage : 10;

    if (pageNow === 1) {
      return false;
    } else {
      axiosAPI
        .get(
          API +
            "kuesioner/bursa-kuesioner?include=dataUser&page[size]=" +
            pageSize +
            "&page[number]=" +
            prevPage +
            "&sort=-created_at"
        )
        .then((res) => {
          setbursaKuesioner(res.data.data);

          setNextPaginate(res.data.meta.current_page + 1);
          setPrevPaginate(res.data.meta.current_page - 1);
          setCurrentPage(res.data.meta.current_page);
          setLastPage(res.data.meta.last_page);
          setPerPage(res.data.meta.per_page);
          setFromPage(res.data.meta.from);
          setToPage(res.data.meta.to);

          if (res.data.data.length === 0) {
            setloadingGetData(4);
          } else {
            setloadingGetData(2);
          }
        })
        .catch((err) => {
          setloadingGetData(3);
        });
    }
  }

  function gotoPage(params) {
    let pageSize = showPerPage ? showPerPage : 10;

    axiosAPI
      .get(
        API +
          "kuesioner/bursa-kuesioner?include=dataUser&page[size]=" +
          pageSize +
          "&page[number]=" +
          params +
          "&sort=-created_at"
      )
      .then((res) => {
        setbursaKuesioner(res.data.data);

        setNextPaginate(res.data.meta.current_page + 1);
        setPrevPaginate(res.data.meta.current_page - 1);
        setCurrentPage(res.data.meta.current_page);
        setLastPage(res.data.meta.last_page);
        setPerPage(res.data.meta.per_page);
        setFromPage(res.data.meta.from);
        setToPage(res.data.meta.to);

        if (res.data.data.length === 0) {
          setloadingGetData(4);
        } else {
          setloadingGetData(2);
        }
      })
      .catch((err) => {
        setloadingGetData(3);
      });
  }

  function showPage(params) {
    let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    setShowPerPage(params);

    axiosAPI
      .get(
        API +
          "kuesioner/bursa-kuesioner?include=dataUser&page[size]=" +
          params +
          "&page[number]=" +
          currentPage +
          "&sort=-created_at"
      )
      .then((res) => {
        setbursaKuesioner(res.data.data);

        setNextPaginate(res.data.meta.current_page + 1);
        setPrevPaginate(res.data.meta.current_page - 1);
        setCurrentPage(res.data.meta.current_page);
        setLastPage(res.data.meta.last_page);
        setPerPage(res.data.meta.per_page);
        setFromPage(res.data.meta.from);
        setToPage(res.data.meta.to);

        if (res.data.data.length === 0) {
          setloadingGetData(4);
        } else {
          setloadingGetData(2);
        }
      })
      .catch((err) => {
        setloadingGetData(3);
      });
  }

  function getMyKuesioner(params) {
    axiosAPI.get(API + "kuesioner/list-kuesioner-terbuka").then((res) => {
      if (!(res.data.status === "failed")) {
        setkuesionerTerbuka(res.data.data);
      }
    });
  }

  function buttonUndang(params) {
    if (params.user_id === datauser.id) {
      return (
        <Link to={"/undang-kuesioner/" + params.id}>
          <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white">
            <p className="text-xs">Undang</p>
          </button>
        </Link>
      );
    } else {
      let user = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
      if (!!user.token) {
        if (params.status_responden === 0) {
          return (
            <button
              onClick={() => setmodalResponden(params.id)}
              className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
            >
              <p className="text-xs">Daftar sebagai responden</p>
            </button>
          );
        } else {
          return (
            <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-200 text-white">
              <p className="text-xs">Anda sudah terdaftar</p>
            </button>
          );
        }
      }
    }
  }

  function renderModalDaftarResponden(params) {
    let button = null;

    if (loadingDaftarResponden === 0) {
      button = (
        <ButtonPrimary
          onClick={() => submitPendafataranResponden()}
          text="Ya, yakin"
          type="solid"
        />
      );
    } else if (loadingDaftarResponden === 1) {
      button = <ButtonPrimary text="Loading" type="solid" />;
    } else if (loadingDaftarResponden === 3) {
      button = (
        <ButtonPrimary
          onClick={() => submitPendafataranResponden()}
          text="Ulangi"
          type="solid"
        />
      );
    }
    return (
      <SMModal
        title="Konfirmasi"
        show={!!modalResponden}
        onClose={() => setmodalResponden(null)}
      >
        <div className="flex flex-col px-4">
          <p className="my-2">
            Apakah anda yakin ingin mendaftar jadi responden?
          </p>

          <div className="flex flex-row gap-2 mt-4">
            {button}
            <ButtonPrimary
              onClick={() => setmodalResponden(null)}
              text="Batal"
              type="outline"
            />
          </div>
        </div>
      </SMModal>
    );
  }

  function submitPendafataranResponden(params) {
    setloadingDaftarResponden(1);
    let body = {
      id: modalResponden,
    };
    axiosAPI
      .post(API + "responden/submit-pendaftaran-responden", body)
      .then((res) => {
        if (res.data.status === "success") {
          swal
            .fire({
              title: "Berhasil",
              text:
                res.data.message +
                ", Halaman akan otomatis reload setelah 3 detik.",
              timer: 3000,
              onOpen: function () {
                swal.showLoading();
              },
            })
            .then(window.location.reload());

          modalResponden(null);
          getBursaKuesioner();
          setloadingDaftarResponden(2);
        } else {
          swal.fire("Gagal", res.data.message, "error");
        }
      })
      .catch((err) => {
        setmodalResponden(null);
        setloadingDaftarResponden(2);
      });
  }

  function renderData(params) {
    if (loadingGetData === 2) {
      return (
        <>
          {bursaKuesioner?.map((val, idx) => {
            const {
              id,
              judul,
              keterangan,
              sifat,
              scoin,
              poin,
              status,
              tanggal_buka,
              tanggal_tutup,
              tipe,
              undang_count,
              data_responden_count,
              daftar_count,
              user_id,
              status_responden,
            } = val ?? null;
            return (
              <div
                key={idx}
                className="flex my-10 flex-col border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg"
              >
                <div className="flex flex-row">
                  <div className="w-10/12">
                    <div className="flex flex-row items-center">
                      <UserCircleIcon className="h-10 w-10 m-2" />
                      <div className="flex-1 flex flex-col px-4">
                        <h1 className="text-md font-bold">
                          {val.relationships.dataUser.name}
                        </h1>
                        <div className="flex flex-row gap-4 items-center">
                          <p className="text-sm text-blue-500">
                            {tanggal_buka}
                          </p>
                          -
                          <p className="text-sm text-blue-500">
                            {tanggal_tutup}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex py-6 flex-col">
                      <h1 className="text-xl font-bold">{judul}</h1>
                      <p className="text-xs s">{keterangan}</p>
                    </div>
                  </div>
                  <div className="w-2/12 flex flex-col p-2 text-center">
                    <span className="py-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 font-bold text-sm">
                      {poin} Poin
                    </span>
                    <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 my-2 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                      {scoin} Scoin
                    </span>
                  </div>
                </div>

                {/* Footer */}

                <div className="flex flex-col">
                  <div className="flex flex-row justify-between items-center">
                    <div className="flex flex-row items-center">
                      <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                        {status == 0 ? "Unpublish" : "Publish"}
                      </span>
                      <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                        {tipe == 0
                          ? "Pilihan Ganda"
                          : tipe == 1
                          ? "File"
                          : "Liklert"}
                      </span>
                    </div>
                    <div>
                      {buttonUndang({
                        user_id: user_id,
                        id: id,
                        status_responden: status_responden,
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          <div class="flex">
            <div class="inline-flex mt-2 xs:mt-0">
              <button
                onClick={() => prevPage()}
                class="inline-flex items-center py-2 px-2 mr-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                <svg
                  class="mr-2 w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>

              <button
                onClick={() => nextPage()}
                class="inline-flex items-center py-2 px-2 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                <svg
                  class="ml-2 w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            <span class="text-sm text-gray-700 dark:text-gray-400 mt-4 ml-3 xs:mt-0 font-medium">
              Show {fromPage} - {toPage} Dari {lastPage} Page |
              <input
                class="shadow appearance-none border rounded w-20 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ml-2"
                type="number"
                name=""
                id=""
                onChange={(evt) => gotoPage(evt.target.value)}
                value={currentPage}
              />
              <select
                class="shadow appearance-none border rounded w-20 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ml-2"
                name=""
                id=""
                onChange={(evt) => showPage(evt.target.value)}
              >
                {/* <option value="5">Show 5</option> */}
                <option value="10">Show 10</option>
                <option value="20">Show 20</option>
                <option value="30">Show 30</option>
                <option value="40">Show 40</option>
                <option value="50">Show 50</option>
              </select>
            </span>
          </div>
        </>
      );
    } else if (loadingGetData === 3) {
      return <div>error</div>;
    } else if (loadingGetData === 4) {
      return (
        <div>
          <NotFound />
        </div>
      );
    } else if (loadingGetData === 1) {
      <div>
        <SkeletonCard />
      </div>;
    }
  }

  return (
    <div
      className="w-full flex flex-row dark:text-white"
      style={{ minHeight: "100vh" }}
    >
      {/* modal daftar responden */}
      {renderModalDaftarResponden()}
      <div className="w-8/12 bg-white dark:bg-gray-900">
        <div
          className="p-6 px-10"
          style={{
            background: `url(${bg}) 100% 100% / 100% 100% no-repeat`,
            minHeight: "400px",
          }}
        >
          <div
            className={
              props.themes !== "light"
                ? "rounded-xl mt-8 border-white dark:border-gray-500 border p-6 bg-blur-dark"
                : "rounded-xl mt-8 border-white dark:border-gray-500 border p-6 bg-blur-light"
            }
          >
            <h1 className="text-2xl font-bold text-white my-6">Bursa</h1>

            <div className="flex flex-row">
              <div className="w-1/2 pr-16">
                <p className="text-white">
                  Temukan berbagai kuesioner menarik dari peserta lain di Bursa
                  Publik Kuesioner. Ikuti, isi, dan jadilah bagian dari
                  komunitas yang saling berbagi informasi untuk menciptakan
                  analisis yang lebih kaya
                </p>
              </div>

              <div className="w-1/2">
                <div
                  style={{ bottom: "-40px" }}
                  className="grid grid-flow-row grid-cols-2 grid-rows-3 relative shadow-xl gap-4 px-8 bg-white border dark:border-gray-500 dark:bg-gray-800 p-4 pb-0 rounded-xl"
                >
                  <SMFilterBursa
                    onSearch={(e) => getBursaKuesioner(e)}
                    onReset={() => getBursaKuesioner()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-6 px-10">{renderData()}</div>
      </div>
      <div className="w-4/12 p-8 bg-gray-200 dark:bg-black">
        <div className="my-2">
          <h1 className="text-lg font-bold my-4">Kuesioner Terbuka</h1>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl">
            <div
              className="bg-white dark:bg-gray-800 rounded-xl p-4"
              style={{
                minHeight: "400px",
                maxHeight: "400px",
                overflowY: "scroll",
              }}
            >
              {kuesionerTerbuka?.length > 0 ? (
                kuesionerTerbuka?.map((val, idx) => {
                  return (
                    <div key={idx} className="flex flex-row p-2 mb-6">
                      <span className="flex items-center justify-center mr-6 h-12 w-12 rounded-full bg-gray-200 dark:bg-gray-900">
                        <BookOpenIcon className="h-10 w-10" />
                      </span>
                      <div className="flex-1">
                        <h1 className="text-sm">{val.judul}</h1>
                        <div className="grid grid-flow-col grid-cols-3 gap-2 my-2">
                          <span className="flex flex-row items-center">
                            <UserCircleIcon className="h-4 w-4 mr-2" />
                            <p className="text-sm">{val.id}</p>
                          </span>
                          <span className="flex flex-row items-center">
                            <UserCircleIcon className="h-4 w-4 mr-2" />
                            <p className="text-sm">{val.scoin} scoin</p>
                          </span>
                          <span className="flex flex-row items-center">
                            <UserCircleIcon className="h-4 w-4 mr-2" />
                            <p className="text-sm">{val.poin} Poin</p>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="flex item-center justify-center">
                  <Lottie options={defaultOptions} height={400} width={400} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <div className="my-2">
          <h1 className="text-lg font-bold my-4">Kuesioner Undangan</h1>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl">
            <div
              className="bg-white dark:bg-gray-800 rounded-xl p-4"
              style={{
                minHeight: "400px",
                maxHeight: "400px",
                overflowY: "scroll",
              }}
            >
              <div className="flex item-center justify-center">
                <Lottie options={defaultOptions} height={400} width={400} />
              </div>
              {kTerbuka.map((val, idx) => {
                return (
                  <div key={idx} className="flex flex-row p-2 mb-6">
                    <span className="flex items-center justify-center mr-6 h-12 w-12 rounded-full bg-gray-200 dark:bg-gray-900">
                      <BookOpenIcon className="h-10 w-10" />
                    </span>
                    <div className="flex-1">
                      <h1 className="text-sm">
                        Jawablah 5 pertanyaan sejarah dalam 48 jam
                      </h1>
                      <div className="grid grid-flow-col grid-cols-3 gap-2 my-2">
                        <span className="flex flex-row items-center">
                          <UserCircleIcon className="h-4 w-4 mr-2" />
                          <p className="text-sm">0/5</p>
                        </span>
                        <span className="flex flex-row items-center">
                          <UserCircleIcon className="h-4 w-4 mr-2" />
                          <p className="text-sm">2h 00j</p>
                        </span>
                        <span className="flex flex-row items-center">
                          <UserCircleIcon className="h-4 w-4 mr-2" />
                          <p className="text-sm">+5 Poin</p>
                        </span>
                      </div>

                      <button className="justify-center w-full px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white">
                        <p className="text-sm">Mulai</p>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}

        {/* <div className="my-2">
          <h1 className="text-lg font-bold my-4">Partisipasi</h1>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl">
            <div
              className="bg-white dark:bg-gray-800 rounded-xl p-4"
              style={{
                minHeight: "400px",
                maxHeight: "400px",
                overflowY: "scroll",
              }}
            >
              <Lottie options={defaultOptions} height={400} width={400} />
              {kTerbuka.map((val, idx) => {
                return (
                  <div key={idx} className="flex flex-row p-2 mb-6">
                    <span className="flex items-center justify-center mr-6 h-12 w-12 rounded-full bg-gray-200 dark:bg-gray-900">
                      <BookOpenIcon className="h-10 w-10" />
                    </span>
                    <div className="flex-1">
                      <h1 className="text-sm">
                        Jawablah 5 pertanyaan sejarah dalam 48 jam
                      </h1>
                      <div className="grid grid-flow-col grid-cols-3 gap-2 my-2">
                        <span className="flex flex-row items-center">
                          <UserCircleIcon className="h-4 w-4 mr-2" />
                          <p className="text-sm">0/5</p>
                        </span>
                        <span className="flex flex-row items-center">
                          <UserCircleIcon className="h-4 w-4 mr-2" />
                          <p className="text-sm">2h 00j</p>
                        </span>
                        <span className="flex flex-row items-center">
                          <UserCircleIcon className="h-4 w-4 mr-2" />
                          <p className="text-sm">+5 Poin</p>
                        </span>
                      </div>

                      <button className="justify-center w-full px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white">
                        <p className="text-sm">Mulai</p>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    themes: state.darkmode.theme,
  };
};

export default connect(mapStateToProps)(Bursa);
